import React from 'react';
import { useTranslation } from 'react-i18next';
import Heading from '../../../generic-components/Heading';

interface IAmountPageHeaderProps {
  subtitle?: string;
}

const STYLES = {
  WRAPPER: 'relative flex flex-col items-center w-full',
  TITLE: 'font-metricRMedium text-[28px] text-bw08 leading-9 mb-[9px]',
  SUBTITLE: 'font-metricR text-md text-bw08 leading-6',
};

export const AmountPageHeader = ({ subtitle }: IAmountPageHeaderProps) => {
  const { t } = useTranslation();
  return (
    <div className={STYLES.WRAPPER}>
      <Heading testId='AmountPageHeader-title' title={t('SEND_MONEY.AMOUNT.TITLE')} className={STYLES.TITLE} />
      {subtitle && <div data-testid='AmountPageHeader-subtitle' className={STYLES.SUBTITLE}>{subtitle}</div>}
    </div>
  );
};

export default AmountPageHeader;
